import { render } from "./root.vue?vue&type=template&id=628544c4&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"

import "./root.vue?vue&type=style&index=0&id=628544c4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628544c4"]])

export default __exports__